function setDashboardData(data) {
	return {
		type: 'GET_DASHBOARD_DATA',
		payload: data,
	};
}

function setDashboardCustomersData(data) {
	return {
		type: 'GET_DASHBOARD_CUSTOMERS',
		payload: data,
	};
}

function setDashboardPaymentsData(data) {
	return {
		type: 'GET_DASHBOARD_PAYMENTS',
		payload: data,
	};
}

function setProductsSalesData(data) {
	return {
		type: 'GET_PRODUCTS_SALE',
		payload: data,
	};
}

function setMembershipSalesData(data) {
	return {
		type: 'GET_MEMBERSHIP_SALE',
	payload: data,
	};
}

export { setDashboardData, setDashboardCustomersData, setDashboardPaymentsData, setProductsSalesData, setMembershipSalesData };
